//
// Javascript for the jQueryAccordian control
//
//  Ben Ramey
//  April 2010
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.jQueryAccordion = function()
{
  $("div.jquery-accordion").show().accordion();
};

$(document).ready(function() { new HEIJS.Controls.jQueryAccordion(); });